import PropTypes from 'prop-types'
import UserService from "../services/UserService";

const RenderOnRole = ({ roles, excludeRoles = [], children }) => (
    UserService.hasRole(roles) && !UserService.hasRole(excludeRoles)
) ? children : null;
 
RenderOnRole.propTypes = {
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
    excludeRoles: PropTypes.arrayOf(PropTypes.string),
}

export default RenderOnRole